export const getIsIqosDomain = () => typeof window !== 'undefined' && window.origin.includes('.iqos.com');
